
import { types, actions } from './requests'
export const CREATESTDARTICLE_TYPES = {
    ...types('CREATESTDARTICLE'),
}
export const CREATESTDARTICLE_ACTIONS = {
    ...actions('CREATESTDARTICLE'),
}